export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_hr.cb7f51997b3ec4a2.json"